export default "__VITE_ASSET__JBeymTXN__"